<template>
  <div>
    <b-tr v-for="tab in topologyItem.Tabs" :key="tab.TabId">
      <b-form-checkbox class="ml-3" :style="'padding-left:' + paddingLeft + 'rem'" v-model="tab.Download" @change="setDownload(tab, tab.Download)">
        <h6>
          {{ tab.DisplayName }}
          <span class="smaller float-md-right mx-2"><b-badge style="font-size: 10px">Tab</b-badge></span>
        </h6>
      </b-form-checkbox>
      <div :style="'padding-left:' + paddingLeft + 'rem'">
        <b-button variant="link" v-b-toggle="'collapse' + tab.SectionTabId">
          Tables
          <b-icon icon="chevron-down" aria-hidden="true"></b-icon>
        </b-button>
      </div>
      <b-collapse :id="'collapse' + tab.SectionTabId" class="mt-2">
        <tables
          :topologyItem="tab" :paddingLeft="paddingLeft + 2" @checkParent="checkParent" />
      </b-collapse>
    </b-tr>
  </div>
</template>
<script lang="ts">
import { Component, Mixins, Prop } from 'vue-property-decorator'
import Tables from './tables.vue'

@Component({
  components: {
    'tables': Tables,
  },
})

export default class extends Mixins() {
  @Prop()
  public topologyItem!: any

  @Prop()
  public paddingLeft!: number

  public checkParent() {
    this.topologyItem.Download = true
    this.$emit('checkParent')
  }

  public setDownload(item: any, value: boolean) {
    if (value) {
      this.checkParent()
    }
    item.Tables?.forEach((ta) => {
      ta.Download = value
      ta.Models?.forEach((m) => {
        m.Download = value
      })
    })
  }
}
</script>
